import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './home/home.component';
import { DiagnosticComponent } from './home/diagnostic/diagnostic.component';
import { ObjectiveComponent } from './home/objective/objective.component';
import { RisksComponent } from './home/risks/risks.component';
import { TakeCareComponent } from './home/take-care/take-care.component';
import { AttentionCentersComponent } from './home/attention-centers/attention-centers.component';
import { AnnouncementComponent } from './home/announcement/announcement.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import {
  MatInputModule,
  MatSelectModule,
  MatIconModule,
  MatButtonModule,
  MatTableModule,
  MatPaginatorModule,
  MatTabsModule,
  MatProgressSpinnerModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatDialogModule,
  MatCheckboxModule,
  MatRadioModule
} from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmptyComponent } from './empty/empty.component';
import { RiskDiagnosisComponent } from './risk-diagnosis/risk-diagnosis.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { ChartsModule } from 'ng2-charts';
import { CountUpModule } from 'countup.js-angular2';
import { DiagnosticCaptureComponent } from './diagnostic-capture/diagnostic-capture.component';
import { DialogCaptureDiagnosticIntroComponent } from './dialogs/dialog-capture-diagnostic-intro/dialog-capture-diagnostic-intro.component';
import { DiagnosticQuizComponent } from './diagnostic-quiz/diagnostic-quiz.component';
import { EmbedVideoService } from 'ngx-embed-video';
import { DialogYoutubeLightboxComponent } from './dialogs/dialog-youtube-lightbox/dialog-youtube-lightbox.component';
import { DiagnosticResultComponent } from './diagnostic-quiz/diagnostic-result/diagnostic-result.component';
import { ConsentComponent } from './home/consent/consent.component';
import { CovidComponent } from './home/covid/covid.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DiagnosticComponent,
    ObjectiveComponent,
    RisksComponent,
    TakeCareComponent,
    AttentionCentersComponent,
    AnnouncementComponent,
    HeaderComponent,
    FooterComponent,
    EmptyComponent,
    RiskDiagnosisComponent,
    StatisticsComponent,
    DiagnosticCaptureComponent,
    DialogCaptureDiagnosticIntroComponent,
    DiagnosticQuizComponent,
    DialogYoutubeLightboxComponent,
    DiagnosticResultComponent,
    ConsentComponent,
    CovidComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatTabsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatDialogModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    ChartsModule,
    CountUpModule,
    MatProgressSpinnerModule,
    MatCheckboxModule
  ],
  providers: [MatDatepickerModule, EmbedVideoService],
  entryComponents: [DialogCaptureDiagnosticIntroComponent, DialogYoutubeLightboxComponent],
  bootstrap: [AppComponent]
})
export class AppModule {}
